import React from "react";
import { IconComponent, icon, CustomTooltip } from "../../..";
import styles from "./StatusIcons.module.css";
import { translate } from "../../../../providers";

export default function StatusIcons({ size = "md" }) {
	return (
		<div className={styles.iconsContainer}>
			<CustomTooltip title={translate("common:header.filter.status.unreviewed")}>
				<span className={styles.iconsContainer__container}>
					<IconComponent color="var(--blue-500)" icon={icon.aitHourglassCircle} size={size} />
				</span>
			</CustomTooltip>
			<CustomTooltip title={translate("common:header.filter.status.yes")}>
				<span className={styles.iconsContainer__container}>
					<IconComponent color="var(--lime-500)" icon={icon.faCheckCircle} size={size} />
				</span>
			</CustomTooltip>
			<CustomTooltip title={translate("common:header.filter.status.pending")}>
				<span className={styles.iconsContainer__container}>
					<IconComponent color="var(--amber-500)" icon={icon.faClock} size={size} />
				</span>
			</CustomTooltip>
			<CustomTooltip title={translate("common:header.filter.status.no")}>
				<span className={styles.iconsContainer__container}>
					<IconComponent color="var(--red-500)" icon={icon.faTimesCircle} size={size} />
				</span>
			</CustomTooltip>
			<CustomTooltip title={translate("common:header.filter.status.not-me")}>
				<span className={styles.iconsContainer__container}>
					<IconComponent icon={icon.aitNotEqualsCircle} size={size} />
				</span>
			</CustomTooltip>
			<span className={styles.iconsContainer__placeholder} />
		</div>
	);
}
